import { ChangeEvent, Ref, useEffect, useState } from 'react'

import {
  AutoCompleteInput,
  Form,
  Grid,
  Input,
  Select,
  UnidadeGestoraFields,
} from 'components'
import { useDebounce } from 'hooks'
import { SPACING } from 'utils'
import { useForm } from 'react-hook-form'
import { RequestGetReport } from 'services/NGT/ReportsBlock'
import { CustomInput } from '../../../../../components/ChipInput/styles';
import { MagnifyingGlassIcon } from 'components/Icons'
import { Flex } from '../../../../../components/FlexCol/index';

export interface IDirectorsManagers {
  tipoAcao: number
  setTipoAcao: (el: number) => void
  handleSearchMatriculaAutoComplete: (
    event: ChangeEvent<HTMLInputElement>
  ) => void
  handleSearchAnalistaAutoComplete: (e: string) => void
  handleSelectedMatricula: (e: string, value: number) => void
  handleSelectedAnalista: (e: string, value: number) => void
  setUnidadeGestoraID: any
  handleChangeMotivosBloqueio: (value: number) => void
  listMotivosBloqueio: any
  motivoBloqueioId: number
  selectedMatricula: string
  selectedAnalita: string
  matriculas: any
  analistas: any
  getData: any
  referencia?: Ref<any>
  cdFolhaRegistroSRV: string
  setCdFolhaRegistroSRV: (value: string) => void
  txDocumento: string
  setTxDocumento: (value: string) => void
  txReferencia: string
  setTxReferencia: (value: string) => void
}
const DirectorsManagers: React.FC<IDirectorsManagers> = ({
  setUnidadeGestoraID,
  selectedMatricula,
  matriculas,
  selectedAnalita,
  analistas,
  handleSearchMatriculaAutoComplete,
  handleSearchAnalistaAutoComplete,
  setTipoAcao,
  getData,
  handleSelectedMatricula,
  handleSelectedAnalista,
  handleChangeMotivosBloqueio,
  listMotivosBloqueio,
  motivoBloqueioId,
  tipoAcao,
  referencia,
  cdFolhaRegistroSRV,
  setCdFolhaRegistroSRV,
  txDocumento,
  setTxDocumento,
  txReferencia,
  setTxReferencia
}) => {
  const listOptonsTipo = [
    { label: 'Bloqueio', value: 0 },
    { label: 'Liberação', value: 1 }
  ]
  const {
    control,
    formState: { errors },
    handleSubmit
  } = useForm({})
  return (
    <>
      <Grid gridCols="1fr 1fr" gridGap="0.1rem" margin="1rem 0.5rem 0.5rem 0rem">
        <Grid gridCols="1fr 2fr" gridGap="0.1rem">
          <AutoCompleteInput
            name="cdMatricula"
            onChangeText={useDebounce(handleSearchMatriculaAutoComplete, 500)}
            value={selectedMatricula || null}
            options={matriculas || []}
            optionValue="label"
            label="Matrícula"
            onChange={(selectedValue, value) => {
              handleSelectedMatricula(selectedValue, value)
            }}
            valueName="value"
            maxLength={100}
            marginLeft='1rem'
            width='100%'
          />
          <AutoCompleteInput
            name="analista"
            marginLeft={SPACING.spacing15}
            marginRight={SPACING.spacing50}
            onChangeText={useDebounce(handleSearchAnalistaAutoComplete, 500)}
            value={selectedAnalita || null}
            options={analistas || []}
            optionValue="label"
            label="Analista"
            onChange={(selectedValue, value) => {
              handleSelectedAnalista(selectedValue, value)
            }}
            valueName="value"
            maxLength={100}
            width='100%'
          />
          {/* <Grid gridCols="3fr" gridGap="0.1rem"> */}
          <Grid gridCols="10fr"
            style={{ flex: 1, gridColumn: 'span 2' }}>
            <Select
              width='100%'
              listOptions={listMotivosBloqueio}
              valueMenu="idMotivoBloqueio"
              labelMenu="txDescricao"
              label="Motivo"
              value={motivoBloqueioId}
              onChange={(e) =>
                handleChangeMotivosBloqueio(parseInt(e.target.value))
              }
              //width='100%'
              marginLeft={SPACING.spacing15}
              marginRight={SPACING.spacing50}
              marginTop={SPACING.spacing5}
              clearSelect={true}
            //style={{ gridColumn: 'span 2' }}
            //disabled={tipoAcao !== 0}
            />
          </Grid>
          {/* </Grid> */}
        </Grid>

        <div style={{ marginBottom: '0.9em' }}>
          <UnidadeGestoraFields
            ref={referencia}
            gridCols={{
              Diretoria: 6,
              DiretoriaExecutiva: 6,
              Gerencia: 6,
              GerenciaGeral: 6,
              spacing: 3
            }}
            onChange={setUnidadeGestoraID}
          />
        </div>
      </Grid >
      <Grid
        gridCols="1fr 1fr 1fr 1fr"
        gridGap="5%"
        margin="1rem 1.25rem 1.25rem 1rem"
        justifyItems="start"
      >
        <Input
          //style={{ marginTop: '-0.6px' }}
          inputIcon={<MagnifyingGlassIcon />}
          onClickIcon={getData}
          label="Referencia"
          placeholder="Nº"
          value={txReferencia}
          onChange={(event) => {
            setTxReferencia(event.target.value)
          }}
          errors={errors}
          width="100%"
          style={{ flex: 1 }}
        />
        <Input
          inputIcon={<MagnifyingGlassIcon />}
          onClickIcon={getData}
          label="Documento"
          placeholder="N°"
          value={txDocumento}
          onChange={(event) => {
            setTxDocumento(event.target.value)
          }}
          errors={errors}
          width="100%"
          style={{ flex: 1 }}
        />
        <Input
          label="Folha de Registro"
          placeholder="N°"
          inputIcon={<MagnifyingGlassIcon />}
          onClickIcon={getData}
          value={cdFolhaRegistroSRV}
          onChange={(event) => {
            setCdFolhaRegistroSRV(event.target.value)
          }}
          errors={errors}
        />
      </Grid>
    </>
  )
}

export default DirectorsManagers
